export default {
  Send: "bank/MsgSend",
  Stake: "staking/MsgDelegate",
  Unstake: "staking/MsgUndelegate",
  Redelegate: "staking/MsgBeginRedelegate",
  ClaimRewards: "distribution/MsgWithdrawDelegationReward",
  Swap: "market/MsgSwap",
  ExecuteContract: "wasm/MsgExecuteContract",
  Vote: "gov/MsgVote",
  Deposit: "gov/MsgDeposit",
  EnableAutoCompound: "msgauth/MsgGrantAuthorization",
  DisableAutoCompound: "msgauth/MsgRevokeAuthorization",
};
